"use strict";

const STORAGE_KEY = "marketing_params";
const EXCLUDE_PARAMS = ["teacher", "teachers"];

const SEARCH_ENGINES = [
  'yandex', 'ya', 'google', 'mail', 'rambler', 'bing', 'duckduckgo'
];


function isLocalStorageAvailable(): boolean {
  try {
    const test = '__localStorage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}


let fallbackStorage: Record<string, string> = {};

function safeGetItem(key: string): string | null {
  try {
    if (isLocalStorageAvailable()) {
      return localStorage.getItem(key);
    } else {
      return fallbackStorage[key] || null;
    }
  } catch (e) {
    return fallbackStorage[key] || null;
  }
}

function safeSetItem(key: string, value: string): boolean {
  try {
    if (isLocalStorageAvailable()) {
      localStorage.setItem(key, value);
      return true;
    } else {
      fallbackStorage[key] = value;
      return true;
    }
  } catch (e) {

    fallbackStorage[key] = value;
    return false;
  }
}

function getCookie(name: string): string | undefined {
  const match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[2]) : undefined;
}

function getUrlParams(): Record<string, string> {
  const params: Record<string, string> = {};
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.forEach((value, key) => {
    if (!EXCLUDE_PARAMS.includes(key)) {
      params[key] = value;
    }
  });
  return params;
}


function getYmClientId(): string | undefined {
  // Основной способ - через yaCounter (как в utmOld.ts)
  const counter = (window as any)['yaCounter97951132'];
  if (counter && typeof counter.getClientID === 'function') {
    try {
      const clientId = counter.getClientID();
      if (clientId) return clientId;
    } catch (e) {
      // Игнорируем ошибки
    }
  }
  
  // Fallback - через куки
  const ymCookie = getCookie('_ym_uid') || getCookie('_ym_97951132_uid');
  if (ymCookie) {
    return ymCookie;
  }
  
  return undefined;
}

function getYmClientIdSync(): string | undefined {
  // Простая синхронная версия как в utmOld.ts
  const counter = (window as any)['yaCounter97951132'];
  if (counter && typeof counter.getClientID === 'function') {
    try {
      return counter.getClientID();
    } catch (e) {
      // Игнорируем ошибки
    }
  }
  return undefined;
}

function getYmClientIdWithRetry(attempts: number = 2, delay: number = 300): Promise<string | undefined> {
  return new Promise((resolve) => {
    function tryGet(remaining: number) {
      const clientId = getYmClientId();
      if (clientId || remaining <= 0) {
        resolve(clientId);
        return;
      }
      
      setTimeout(() => tryGet(remaining - 1), delay);
    }
    
    tryGet(attempts);
  });
}

function extractDomainFromReferrer(referrer: string): string | undefined {
  try {
    const url = new URL(referrer);
    let hostname = url.hostname;
    
  
    if (hostname.startsWith('www.')) {
      hostname = hostname.substring(4);
    }
    
   
    const domainParts = hostname.split('.');
    if (domainParts.length >= 2) {
   
      return domainParts[domainParts.length - 2];
    }
    
    return hostname;
  } catch (e) {
    return undefined;
  }
}

function getReferrerParams(): Record<string, string> {
  const params: Record<string, string> = {};
  
  if (document.referrer) {
    const domain = extractDomainFromReferrer(document.referrer);

    if (domain && !domain.includes('100points') && SEARCH_ENGINES.includes(domain)) {
      params.utm_source = domain;
      params.utm_medium = 'organic';
      params.utm_campaign = 'seo';
    }
  }
  
  return params;
}

function saveParamsToLocalStorage(params: Record<string, string>): void {
  if (Object.keys(params).length === 0) return;

  try {
    safeSetItem(STORAGE_KEY, JSON.stringify(params));
  } catch (e) {

  }
}

async function collectAndStoreUrlParams() {
  try {
    const urlParams = getUrlParams();
    
    // Сначала пытаемся получить ymClientId синхронно (как в utmOld.ts)
    let ymClientId = getYmClientIdSync();
    
    // Если не получилось, используем retry с короткими задержками
    if (!ymClientId) {
      ymClientId = await getYmClientIdWithRetry(2, 200);
    }

    const referrerParams = getReferrerParams();
    const isOrganicSearch = Object.keys(referrerParams).length > 0;
    const hasUrlParams = Object.keys(urlParams).length > 0;

    // Всегда сохраняем ymClientId если он доступен, независимо от других параметров
    if (ymClientId) {
      // Получаем существующие параметры
      let existingParams: Record<string, string> = {};
      try {
        const stored = safeGetItem(STORAGE_KEY);
        if (stored) {
          existingParams = JSON.parse(stored);
        }
      } catch (e) {
        // Игнорируем ошибки парсинга
      }

      // Добавляем ymClientId к существующим параметрам
      existingParams.ym_client_id = ymClientId;

      // Если визит "значимый", то полностью перезаписываем параметры
      if (hasUrlParams || isOrganicSearch) {
        // Сначала берем органические, затем добавляем/перезаписываем параметры из URL
        const finalParams: Record<string, string> = { ...referrerParams, ...urlParams };
        finalParams.ym_client_id = ymClientId;
        saveParamsToLocalStorage(finalParams);
      } else {
        // Если визит обычный, то просто обновляем ymClientId в существующих параметрах
        saveParamsToLocalStorage(existingParams);
      }
    } else if (hasUrlParams || isOrganicSearch) {
      // Если ymClientId недоступен, но есть другие значимые параметры
      const finalParams: Record<string, string> = { ...referrerParams, ...urlParams };
      saveParamsToLocalStorage(finalParams);
    }
    
  } catch (error) {
    // console.error('Error in collectAndStoreUrlParams:', error);
  }
}


function initUtmTracking() {

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collectAndStoreUrlParams);
  } else {

    collectAndStoreUrlParams();
  }
  

  if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {

    setTimeout(collectAndStoreUrlParams, 2000);
    setTimeout(collectAndStoreUrlParams, 5000);
  }
}


initUtmTracking();


(window as any).utmTracking = {
  collectAndStoreUrlParams,
  getYmClientId,
  getYmClientIdSync,
  getYmClientIdWithRetry,
  isLocalStorageAvailable,
  safeGetItem,
  safeSetItem
};

